export default {"src":"/_next/static/media/ethereum.84ed15ef.svg","height":14,"width":14};